import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './MedicalClinicComponent.module.scss';
import metadata from './MedicalClinicComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function MedicalClinicComponent(props) {

    const {
        data: MedicalClinicComponentVM,
        updateWizardData,
        submissionVM,
        MedicalClinicComponentPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);

    const addMedicalClinic = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            MedicalClinicComponentVM.value = MedicalClinicComponentVM.value || []

            const { _xCenter, _dtoName } = MedicalClinicComponentVM;

            const MedicalClinicObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            MedicalClinicObjVM.value.perOfRev2 = 0
            MedicalClinicObjVM.value.annNumOfPro3 = 0

            MedicalClinicComponentVM.pushElement(
                MedicalClinicObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, MedicalClinicComponentVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            MedicalClinicComponentVM.value.splice(index, 1);
            _.set(submissionVM.value, MedicalClinicComponentPath, MedicalClinicComponentVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, MedicalClinicComponentPath, MedicalClinicComponentVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'medCli1') {
                const value = (item && item.medCli1) ? item.medCli1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = MedicalClinicComponentVM.length > 0 && MedicalClinicComponentVM.children[index].medCli1
                    // eslint-disable-next-line security/detect-object-injection
                    ? MedicalClinicComponentVM.children[index].medCli1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.medCli1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'perOfRev2') {
                const value = item.perOfRev2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.perOfRev2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'annNumOfPro3') {
                const value = item.annNumOfPro3;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.annNumOfPro3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des4' && !_.isUndefined(item.medCli1) && item.medCli1 === 'Other') {
                const value = item.des4 ? item.des4 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
        }, [handleValueChange, translator, MedicalClinicComponentVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`MedicalClinicTable`]: {
            data: MedicalClinicComponentVM.value,
        }

    }), [MedicalClinicComponentVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addMedicalClinic,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            MedicalClinicComponentVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [MedicalClinicComponentVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={MedicalClinicComponentVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

MedicalClinicComponent.propTypes = wizardProps;
export default withRouter(MedicalClinicComponent);
